import { render, staticRenderFns } from "./AssignSupervisorAccess.vue?vue&type=template&id=a62c853e"
import script from "./AssignSupervisorAccess.vue?vue&type=script&lang=js"
export * from "./AssignSupervisorAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a62c853e')) {
      api.createRecord('a62c853e', component.options)
    } else {
      api.reload('a62c853e', component.options)
    }
    module.hot.accept("./AssignSupervisorAccess.vue?vue&type=template&id=a62c853e", function () {
      api.rerender('a62c853e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settlement/AssignSupervisorAccess.vue"
export default component.exports